import {History as State} from './history-state'
import _ from 'lodash'
import Backbone from 'backbone'

function History (canvas) {
  this.canvas = canvas
  this.state = new State
}

History.prototype.undo = function () {
  var result = this.quietly(this.state.undo.bind(this.state))
  this.trigger('undo')
  return result
}

History.prototype.redo = function () {
  var result = this.quietly(this.state.redo.bind(this.state))
  this.trigger('redo')
  return result
}

History.prototype.record = function () {
  if (this._ignore) {
    return
  }
  this.recordState(true)
  this.trigger('record')
}

History.prototype.pop = function () {
  this.state.pop()
}

History.prototype._wobChange = function (wob) {
  let changed = wob.changedAttributes()

  // Trigger resize events if the wob changed dimensions or moved
  if (wob.hasChanged('width') || wob.hasChanged('height') || wob.hasChanged('top') || wob.hasChanged('left')) {
    wob.trigger('resize', wob, wob._previousAttributes)
  }
}

History.prototype.recordState = function (isUndo) {
  var wobs = this.canvas.collection.toJSONWithWidgets()
    , serialized = JSON.stringify(wobs)
    , self = this

  var action = function (state, isUndo) {
    self.recordState(!isUndo)

    let wobs = JSON.parse(state)

    function onChange () {
      self._wobChange.apply(self, arguments)
    }

    function onAddRemove () {
      // SpiderStrategies/Scoreboard#43044 History._wobChange() won't recognize that
      // a new or removed model has changed (it checks for dimension changes), so
      // just explicitly tell the canvas to resize
      self.canvas.resize()
    }

    // Register the event listeners so we can determine what changed w/ this historical action
    self.canvas.collection.on('change', onChange)
    self.canvas.collection.on('add remove', onAddRemove)

    self.canvas.collection.set(wobs)

    // We no longer care, remove the listeners
    self.canvas.collection.off('change', onChange)
    self.canvas.collection.off('add remove', onAddRemove)
    self.canvas.collection.sync('update', self.canvas.collection)
  }

  this.state.add(new State.Action(action, serialized), isUndo)
}

History.prototype.hasUndo = function () {
  return this.state.undos.length > 0
}

History.prototype.hasRedo = function () {
  return this.state.redos.length > 0
}

History.prototype.release = function () {
  this.state.clear()
  this.state = null
}

// Performs the given callback while ensuring that
// only a single history record is created
History.prototype.transaction = function (cb) {
  this.record()
  return this.quietly(cb)
}

// Performs the given callback while ensuring that
// no history records are created
History.prototype.quietly = function (cb) {
  this._ignore = true
  var result = cb()
  delete this._ignore
  return result
}

_.extend(History.prototype, Backbone.Events)

export default History
